import { useTheme } from '@/components/ThemeProvider';
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle, SheetTrigger } from '@/components/ui/sheet';
import { useState } from 'react';
import SettingController from './SettingController';

interface IProps {}

export default (_: IProps) => {
  const { theme } = useTheme();
  const [open, setOpen] = useState(false);
  const imgSrc = theme == 'dark' ? '/icon/Setting.svg' : '/icon/Setting_black.svg';
  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger>
        <div className="px-[8px] h-[32px] rounded-[8px] text-[12px] flex border-borderColor border-[1px] items-center gap-x-[4px]">
          <img src={imgSrc} className="size-[18px]" />
        </div>
      </SheetTrigger>
      <SheetContent
        side="bottom"
        hideCloseIcon
        className="p-[16px] border-t-[1px] overflow-y-auto border-t-borderColor min-h-[500px] rounded-tl-[12px] rounded-tr-[12px] outline-none"
        onOpenAutoFocus={(e) => e.preventDefault()}
      >
        <SheetHeader className="hidden" />
        <SheetTitle className="hidden" />
        <SheetDescription className="hidden" />
        <SettingController setOpen={setOpen} />
      </SheetContent>
    </Sheet>
  );
};
